import React,{useState, useEffect} from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../componets/Header';
import Footer from '../componets/Footer';


const MainLayout = () => {


  return (
    <div>
        <Header />
        <main className='main-layout'>
            <Outlet />
        </main>
        <Footer />
    </div>
  )
}

export default MainLayout